const LOCATION_NAME_RULES: Record<string, { regex: RegExp; style: string; hint: string }> = {
  header: {
    regex: /^[a-z0-9-]+$/,
    style: 'kebab-case',
    hint: 'Use lowercase letters, numbers, hyphens (e.g. x-api-key)',
  },
  query: {
    regex: /^[a-z0-9_]+$/,
    style: 'snake_case',
    hint: 'Use lowercase letters, numbers, underscores (e.g. page_size)',
  },
  path: {
    regex: /^[a-z][a-z0-9-]*$/,
    style: 'kebab-case',
    hint: 'Start with lowercase letter, then lowercase letters, numbers, hyphens (e.g. user-id)',
  },
  body: {
    regex: /^[a-z][a-zA-Z0-9_-]*$/,
    style: 'standard naming',
    hint: 'start with lowercase letter, then other characters (e.g. user_id, apiKey)',
  },
};

/** Placeholder for parameter name inputs: one word, or snake_case when using multiple words. */
export const PARAMETER_NAME_PLACEHOLDER = 'e.g. name or add_name';

export interface NameValidationError {
  message: string;
}

export const validateParameterName = (
  name: string,
  location: string,
): NameValidationError | null => {
  if (!name) return null;

  // Naming validation temporarily disabled — allow any parameter name format.
  // const rule = LOCATION_NAME_RULES[location];
  // if (!rule) return null;
  //
  // if (!rule.regex.test(name)) {
  //   return {
  //     message: `${rule.hint}`,
  //   };
  // }

  return null;
};
